import styled from "styled-components";

export const OrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  ${(p) => p.theme.isNewLook && `gap: 16px;`}
`;
